export const AVATAR_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const AVATAR_SLIDE_HEIGHT = {
  SMALL: 360,
  MEDIUM: 480,
  LARGE: 560
};

export const AVATAR_SLIDE_WIDTH = {
  SMALL: 288,
  MEDIUM: 360,
  LARGE: 448
};

export const MAX_DESCRIPTION_LINE_COUNT_PRE_AUTH = 5;

export const MAX_DESCRIPTION_LINE_COUNT_POST_AUTH = 3;

export const RESPONSIVE_FIXED_WIDTH_COLUMN_PROPS = {
  padding: 0,
  s: { width: 1 },
  m: { width: 1 },
  l: { width: 10 / 12 },
  xl: { width: 8 / 12 }
};

export const SINGLE_SPEAKER_AVATAR_SIZES = {
  SMALL: 9.8, // rem => img width ~166
  MEDIUM: 13.4, // rem => img width ~227
  LARGE: 16.8 // large rem => img width ~282
};

export const TWO_SPEAKERS_AVATAR_ONE_SIZES = {
  SMALL: 7.6, // rem => img width ~115
  MEDIUM: 9.2, // rem => width ~167
  LARGE: 12.6 // ~181
};

export const TWO_SPEAKERS_AVATAR_TWO_SIZES = {
  SMALL: 5.4, // rem => img width ~91
  MEDIUM: 7, // rem => width ~134
  LARGE: 9
};

export const SLIDER_DOTS_TOP_MARGIN = {
  SMALL: 25,
  MEDIUM: 35.5,
  LARGE: 43.75
};
